<template>
    <div>
        
        <div class="content"  v-if="purchase.payment_type === 'pix' " >

            <img
                style="width:auto; max-height:200px"
                :src="purchase.payment_link"
            />
           
            <div class="d-sm-flex justify-content-sm-between">
                    <c-button
                        :backgroundColor="
                            $root.$children[0].theme.products.button
                                .background_color
                        "
                        :backgroundColorHover="
                            $root.$children[0].theme.products.button
                                .background_color_hover
                        "
                        :color="$root.$children[0].theme.products.button.color"
                        :colorHover="
                            $root.$children[0].theme.products.button.color_hover
                        "
                        :borderColor="
                            $root.$children[0].theme.products.button
                                .border_color
                        "
                        :borderColorHover="
                            $root.$children[0].theme.products.button
                                .border_color_hover
                        "
                        :borderRadius="
                            $root.$children[0].theme.products.button
                                .border_radius
                        "
                        margin="0px"
                        textTransform="uppercase"
                        height="unset"
                        minWidth="124px"
                        padding="0.5rem 2rem"
                        display="inline-block"
                        textAlign="center"
                        lineHeight="1.5"
                        letterSpacing="0.8px"
                        transition="all .3s"
                        fontSize="1.4rem"
                        type="button"
                        v-clipboard:copy="pix_data.payload_pix"
                        v-clipboard:success="onCopyPix"
                        v-clipboard:error="onErrorPix"
                    >
                        Copiar chave
                    </c-button>
                </div>
        </div>
        <!-- <ModalApp name="pix_modal" style="overflow-y: auto;">
            <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                    <c-heading-3
                        class="text-center"
                        style="padding-bottom:10px"
                        >{{ gateway.nome_razao_social }}</c-heading-3
                    >
                    <img
                        style="width:auto; max-height:200px"
                        :src="purchase.payment_link"
                    />
                    <div style="width:80%">
                        <c-paragraph
                            class="text-center"
                            style="margin-top: 30px;"
                            >{{ gateway.pix_msg }}</c-paragraph
                        >
                    </div>
                </div>
                
            </div>
            <div class="modal-footer float-right">
                <c-button
                    type="button"
                    data-dismiss="modal"
                    backgroundColor="#dc3545"
                    backgroundColorHover="#bd2130"
                    color="#fff"
                    colorHover="#fff"
                    :textTransform="
                        $root.$children[0].theme.products.button.text_transform
                    "
                    :borderRadius="
                        $root.$children[0].theme.products.button.border_radius
                    "
                    borderColor="transparent"
                    borderColorHover="transparent"
                    margin="0px 3rem 0px 0px"
                    height="unset"
                    minWidth="124px"
                    padding="1rem 2rem"
                    display="inline-block"
                    textAlign="center"
                    lineHeight="1.5"
                    letterSpacing=".1rem"
                    transition="all .3s"
                >
                    Cancelar
                </c-button>
                <c-button
                    data-dismiss="modal"
                    :backgroundColor="
                        $root.$children[0].theme.products.button
                            .background_color
                    "
                    :backgroundColorHover="
                        $root.$children[0].theme.products.button
                            .background_color_hover
                    "
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="
                        $root.$children[0].theme.products.button.color_hover
                    "
                    :borderColor="
                        $root.$children[0].theme.products.button.border_color
                    "
                    :borderColorHover="
                        $root.$children[0].theme.products.button
                            .border_color_hover
                    "
                    :borderRadius="
                        $root.$children[0].theme.products.button.border_radius
                    "
                    margin="0px 3rem 0px 0px"
                    textTransform="uppercase"
                    height="unset"
                    minWidth="124px"
                    padding="1rem 2rem"
                    display="inline-block"
                    textAlign="center"
                    lineHeight="1.5"
                    letterSpacing="unset"
                    transition="all .3s"
                >
                    OK
                </c-button>
            </div>
        </ModalApp> -->
    </div>
</template>

<script>
import ModalApp from "../ModalApp.vue";
import { CHeading3, CHeading4, CParagraph } from "../Styles/Components/styled";
import { CButton } from "../Styles/Button/styled";
import Currency from "../../helpers/parseCurrency";
import { mapActions, mapState } from "vuex";
export default {
    name: "CompletedPurchase",
    components: {
        ModalApp,
        "c-button": CButton,
        "c-heading-3": CHeading3,
        "c-paragraph": CParagraph,
        "c-heading-4": CHeading4
    },
    props: {
        purchase: { required: true },
        gateway: { required: true }
    },
    data() {
        return {
            pix_data: {
                payload_pix: null
            },
            url_pix: "",
            currency: Currency
        };
    },
    methods: {
        ...mapActions("toast", [
            "setShowToast",
            "setMessageToast",
            "setTimerToast",
            "setIconToast",
            "setThemeToast"
        ]),
        initPixKey() {
            if (this.purchase?.payload) {
                try {
                    const parsed = JSON.parse(this.purchase.payload);
                    this.pix_data.payload_pix = parsed.payload_pix || null;
                } catch (e) {
                    this.pix_data.payload_pix = null;
                }
            }
        },
        ensurePixKey() {
            // Se o plugin falhar porque a chave está vazia, tenta novamente
            if (!this.pix_data.payload_pix) {
                this.initPixKey();
                if (!this.pix_data.payload_pix && this.pixKey) {
                    this.pix_data.payload_pix = this.pixKey;
                }
            }
            // fallback manual caso o v-clipboard não funcione
            if (this.pixKey) {
                navigator.clipboard?.writeText(this.pixKey).then(() => {
                    // Se já tiver sucesso via fallback, evita duplicar toast
                    if (!this._clipboardSuccessHandled) {
                        this._clipboardSuccessHandled = true;
                        this.onCopyPix();
                        setTimeout(() => (this._clipboardSuccessHandled = false), 500);
                    }
                }).catch(() => {});
            }
        },
        onCopyPix: function(e) {
            this.alertToast(
                "Chave copiada para a área de transferência!",
                "check",
                "success"
            );
        },
        onErrorPix: function(e) {
            this.alertToast(
                "Não foi possível copiar a chave!",
                "exclamation-triangle",
                "danger"
            );
        },
        showModalPix() {
            let payload_pix = ''
            if(this.purchase.payload) {
                payload_pix = JSON.parse(this.purchase?.payload).payload_pix
            }
            this.$root.showModalApp("pix_modal");
            this.$set(this.pix_data, "payload_pix", payload_pix);
        },
        alertToast(
            msg = null,
            icon = "exclamation",
            theme = "warning",
            timer = 7
        ) {
            this.setThemeToast(theme);
            this.setMessageToast(msg);
            this.setIconToast(icon);
            this.setTimerToast(timer);
            this.setShowToast(true);
            setTimeout(() => {
                this.setShowToast(false);
            }, timer * 1000);
        }
    },
    computed: {
        pixKey() {
            if (this.pix_data.payload_pix) return this.pix_data.payload_pix;
            // tenta extrair direto do purchase.payload
            if (this.purchase?.payload) {
                try {
                    const parsed = JSON.parse(this.purchase.payload);
                    return parsed.payload_pix || "";
                } catch (e) {
                    return "";
                }
            }
            return "";
        }
    },
    mounted() {
        this.initPixKey()
    }

};
</script>

<style>
.content{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    padding: 1.5rem 0;
}
</style>
